import Item from './item'

interface IItemsProps {
    moneyPools: Array<MoneyPool>
}

// A fragment, not a wrapper: the cards are direct children of the tab's
// `flex flex-col gap-3` column so every card on the screen — hero, cashbox,
// banner, moneypool — sits on the same rhythm.
export default function MoneyPools({ moneyPools }: IItemsProps) {
    return (
        <>
            {moneyPools.map((item) => (
                <Item item={item} key={item.id} />
            ))}
        </>
    )
}
